/**
 * Service: i18next Client
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdI18nService for ES6 usage
 *          3.3.0 #272 Remove redirect from oauth2 client & refactor wdEnvironment
 *          3.2.0 #267 Add i18n-client to angular service
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2016-2020 Build Centrix
 */

var wdI18nService = angular.module('wd.service.i18n', [])

.factory(
    'wdI18nService', function ()
    {
        var I18n;

        I18n = (typeof global !== 'undefined' ? /* istanbul ignore next */ global : window).i18nClient;

        //Unit Test Note: http://stackoverflow.com/questions/27738903/provider-xx-must-return-a-value-from-get-factory-method-in-angularjs
        return { I18n: I18n };
    }
);

if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdI18nService;
}
// EOF